import { render, staticRenderFns } from "./SlideInPanel.vue?vue&type=template&id=5f0c90e7&scoped=true&"
import script from "./SlideInPanel.vue?vue&type=script&lang=js&"
export * from "./SlideInPanel.vue?vue&type=script&lang=js&"
import style0 from "./SlideInPanel.vue?vue&type=style&index=0&id=5f0c90e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0c90e7",
  null
  
)

export default component.exports